import SectionHeader from "./SectionHeader";
import { works } from "@/mocks/manhwa";

export default function LatestUpdates() {
  const latest = works.slice(0, 6);

  return (
    <section id="updates" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeader
        tag="最新更新"
        title="追更列表 · 最新话同步中"
        desc="虚空韩漫网实时同步热门韩漫最新话与连载进度，新作上线即时标记，打开就能看到每部作品更新到哪。"
      />

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6 md:gap-5">
        {latest.map((item) => (
          <article key={item.id} className="group flex flex-col">
            <div className="relative overflow-hidden rounded-xl bg-background-100">
              <img
                src={item.cover}
                alt={`${item.title} 韩漫最新话封面`}
                className="aspect-[3/4] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute left-2 top-2 flex gap-1.5">
                <span className="rounded-full bg-primary-500 px-2 py-0.5 text-[11px] font-semibold text-background-50">
                  {item.lastChapter}
                </span>
                {item.isNew && (
                  <span className="rounded-full bg-accent-500 px-2 py-0.5 text-[11px] font-semibold text-background-50">
                    新作
                  </span>
                )}
              </div>
              <div className="absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-black/80 to-transparent p-3 transition-transform duration-300 group-hover:translate-y-0">
                <p className="text-xs leading-snug text-background-100 line-clamp-3">{item.description}</p>
              </div>
            </div>
            <h3 className="mt-2.5 text-sm font-semibold text-foreground-950 md:text-base">{item.title}</h3>
            <p className="mt-0.5 text-xs text-foreground-500">{item.genre}</p>
            <div className="mt-1.5 flex items-center justify-between text-xs">
              <span className="inline-flex items-center gap-1 text-primary-600">
                <i className="ri-time-line text-sm"></i>
                {item.updateInfo}
              </span>
              <span className="inline-flex items-center gap-1 text-foreground-500">
                <i className="ri-star-fill text-sm text-accent-500"></i>
                {item.rating}
              </span>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-10 text-center">
        <a
          href="#genres"
          className="inline-flex h-12 items-center gap-2 whitespace-nowrap rounded-full bg-primary-100 px-8 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-200"
        >
          浏览全部连载作品
          <i className="ri-arrow-right-line text-base"></i>
        </a>
      </div>
    </section>
  );
}